import React from 'react';
var StringInput = function StringInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("input", {
    type: "text",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value || ''
  });
};
export default StringInput;